import VideoPlayer from '@/js/core/VideoPlayer'
import gsap from 'gsap'
import $ from 'jquery'

export default class MediaVideo extends VideoPlayer {
  static root = '[data-media-video]'

  actions = {
    isFullscreen: 'update',
    intersection: 'update',
  }

  selectors = {
    ...this.selectors,
    'play': '[data-video-play]',
    'poster': '[data-video-poster]',
  }

  listeners = {
    'click @play': () => {
      if ($.device.mobile.phone)
        this.fullscreenRequest(this.$els.video)
      this.playVideo()
    },

    'play video': () => {
      if (!$.device.mobile.phone) {
        this.hidePoster()
      }
    },
    
    'pause video': () => {
      if (!$.device.mobile.phone) {
        this.showPoster()
      }
    },
  }

  hidePoster () {
    gsap.timeline({ defaults: { ease: 'power2.out' } })
        .to(this.$els.play, { autoAlpha: 0, duration: .3 }, '<')
        .to(this.$els.poster, { autoAlpha: 0, duration: .6 }, '<+.12')
  }

  showPoster () {
    gsap.timeline({ defaults: { ease: 'power2.out' } })
        .to(this.$els.poster, { autoAlpha: 1, duration: .6 }, '<')
        .to(this.$els.play, { autoAlpha: 1, duration: .3 }, '<+.12')
  }

  update () {
    const { isFullscreen } = this.state
    if (!isFullscreen) {
      this.pauseVideo()
    }
  }
}